import img from "Assets/Images/ProfileAvatar.png";
import NavIconLayout from "components/ContentNavBar/NavIconLayout";
import { IoMdMore } from "react-icons/io";
import { IoArrowBackCircle } from "react-icons/io5";
import { Link } from "react-router-dom";
import ChatOptions from "./ChatOptions";

function ChatHeaderOpenChat({
  sidePanel,
  receiver,
  setSelectedChat,
  setChatIsOpen,
  handleApproveChat, // handleApproveChat("rejected/approved");
  chatStatus,
  chatData,
  updateBlockChatStatusFromOpenChat
}: any) {
  // console.log("ChatHeaderOpenChat : ", receiver);
  
  const handleBackButton = () => {
    setSelectedChat(null);
    if (setChatIsOpen) {
      setChatIsOpen(false);
    }
  };
  return (
    <>
      <div
        className={`flex w-full items-center justify-between border-b border-white/10 bg-[#1E1E1E] p-3 max-sm:pl-1 ${
          sidePanel ? `` : `sm:rounded-t-2xl`
        }`}
      >
        <div className="flex items-center justify-start gap-2">
          {/* back button */}
          <div
            className={`${
              sidePanel ? `` : `md:hidden`
            } cursor-pointer text-4xl text-white/80 transition-colors hover:text-white`}
            onClick={handleBackButton}
          >
            <IoArrowBackCircle />
          </div>
          <Link to={`/profile/${receiver?.username}`}>
            {/* user details - image */}
            <div className="flex items-center">
              <img
                src={receiver ? receiver?.artwork_url : img}
                alt="profile pic"
                className="h-12 w-12 rounded-full object-cover ring-1 ring-white/10"
              />

              {/* user details - name & last seen */}
              <div className="ml-3 text-white">
                <p
                  className="text-[15px] font-semibold"
                  onClick={() => {
                    setSelectedChat(null);
                  }}
                >
                  {receiver?.name}
                </p>
              </div>
            </div>
          </Link>
        </div>

        {/* future options */}
        <div className="flex items-center justify-end gap-3 text-white/50">
          {/* <IoMdMore className="text-3xl cursor-pointer" /> */}
          {/* <ChatOptions /> */}
          <NavIconLayout
            icon={<IoMdMore />}
            content={
              <ChatOptions
                handleApproveChat={handleApproveChat}
                chatStatus={chatStatus}
                chatData={chatData}
                updateBlockChatStatusFromOpenChat={updateBlockChatStatusFromOpenChat}
              />
            }
          />
        </div>
      </div>
    </>
  );
}

export default ChatHeaderOpenChat;
